import { endpoints, request } from '!core/api';

export const userAttributesServices = {
  getUserAttributes: ({ id }) =>
    request.get(endpoints.chnn(`wsbGetUserAttributes?attributeId=${id}`)),
  setUserAttribute: ({ id, value }) =>
    request.put(
      endpoints.chnn(
        `wsbSetUserAttributes?attributeId=${id}&attributeValue=${value}`,
      ),
    ),
};
